var map = {
	"./gamelist11.png": "b803",
	"./gamelist12.png": "7afb",
	"./gamelist13.png": "c844",
	"./gamelist14.png": "e78f",
	"./gamelist15.png": "fb72",
	"./gamelist21.png": "d797",
	"./gamelist22.png": "58c1",
	"./gamelist23.png": "e779",
	"./gamelist24.png": "8f61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47f0";